import { render } from "./Eleganza4.vue?vue&type=template&id=8899e08e&scoped=true"
import script from "./Eleganza4.vue?vue&type=script&lang=js"
export * from "./Eleganza4.vue?vue&type=script&lang=js"

import "./Eleganza4.vue?vue&type=style&index=0&id=8899e08e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8899e08e"

export default script